import styled, { keyframes } from 'styled-components';
import React, { useEffect, useCallback, useState, useRef } from "react";


const Screen2 = () => {
    const [selected, setSelected] = useState(false);

    return (
        <Container>
            <Question>
                How would you like to optimize your plan?
            </Question>

            <Responses>
                <Response selected={selected==1} onClick={()=>setSelected(1)}>
                    Optimize my plan towards a particular outcome factor
                </Response>
                <Response selected={selected==2} onClick={()=>setSelected(2)}>
                    Optimize my plan towards a particular culture factor
                </Response>

                <Response selected={selected==3} onClick={()=>setSelected(3)}>
                    Custom
                </Response>
            </Responses>
        </Container>
    )

}

export default Screen2;

const Container = styled.div`
    width:100%;
    font-family:"Raleway";
`

const Question = styled.div`
    font-size:28px;
    margin-bottom:40px;
    font-weight:600;
    line-height:1.2
`

const Responses = styled.div`
    display:flex;
    flex-direction:column;
`

const Response = styled.div`
    padding:20px;
    border:1px solid #ccc;
    margin-bottom:10px;
    cursor:pointer;

    background-color:${props=>props.selected ? "#f0f0f0" : "white"};
    color:${props=>props.selected ? "#333" : "#666"};
    transition:0.3s;
`

